import {
  Button,
  Callout,
  FormGroup,
  HTMLSelect,
  InputGroup,
  TextArea,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { INotaVar } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { NotaVarFcpStore } from "../../stores/vars/NotaVarFcpStore";
import { sortBy, VARS } from "../../utils";
import { toast } from "react-toastify";

interface NotaVarFcpFormProps {
  varFcpId?: number;
}

interface NotaVarFcpFormState {
}

@observer
export class NotaVarFcpForm
  extends React.Component<NotaVarFcpFormProps, NotaVarFcpFormState>
{
  focusEl: HTMLElement;
  notaVarFcp: INotaVar;
  saving: boolean = false;

  obs = observable({
    saving: false as boolean,
    varFcpId: window.location.pathname.split("/")[3] as string
  })

  constructor(props: NotaVarFcpFormProps) {
    super(props);
    this.notaVarFcp = createViewModel(observable({
      nome: "",
      campo: "",
    }));
    AppStore.setTitle("Criar/Editar Variável");
  }

  async componentDidMount() {
    this.focusEl.focus();
    if (this.obs.varFcpId) {
      let notaVar = await NotaVarFcpStore.get(this.obs.varFcpId);
      this.notaVarFcp._id = notaVar._id
      this.notaVarFcp.campo = notaVar.campo
      this.notaVarFcp.descricao = notaVar.descricao
      this.notaVarFcp.nome = notaVar.nome
    }
  }

  handleSave = async () => {

    if (this.notaVarFcp.nome == "") {
      toast.warn('Preencha o campo Nome', {});
      return
    }

    if (this.notaVarFcp.campo == "") {
      toast.warn('Selecione um Campo!', {});
      return
    }

    if (this.notaVarFcp.descricao == "") {
      toast.warn('Preencha o campo Descrição', {});
      return
    }

    this.obs.saving = true;

    try {

      await NotaVarFcpStore.handleSave(this.notaVarFcp);

      AppStore.setLocation("/vars-fcp");

      var interval = setInterval(NotaVarFcpStore.handleRefresh, 500);

    } catch (er) { }

    this.obs.saving = false;

  };

  handleCancel = () => {
    AppStore.setLocation("/vars-fcp");
  };

  render() {
    let sortedVars = sortBy(VARS, "nome");
    let varOptions = sortedVars?.map(v => {
      return <option key={v.campo} value={v.campo}>{v.nome || v.campo}</option>;
    });

    let selectedVar = VARS.find(v => v.campo == this.notaVarFcp.campo);

    return (
      <div>
        <MDBRow>
          <MDBCol md="6">
            <FormGroup
              label="Nome"
              labelFor="nome"
            >
              <InputGroup
                id="nome"
                inputRef={el => this.focusEl = el}
                defaultValue={this.notaVarFcp.nome}
                onChange={(e: any) => this.notaVarFcp.nome = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Campo"
              labelFor="campo"
            >
              <HTMLSelect
                onChange={e => this.notaVarFcp.campo = e.target.value}
                defaultValue={this.notaVarFcp.campo}
              >
                <option value="">Selecionar um campo...</option>
                {varOptions}
              </HTMLSelect>
            </FormGroup>

            <Callout icon="help" style={{ marginTop: 15, marginBottom: 20 }}>
              {selectedVar && selectedVar.descricao || "Sem descrição"}
            </Callout>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
            >
              <TextArea
                defaultValue={this.notaVarFcp.descricao}
                onChange={(e: any) => this.notaVarFcp.descricao = e.target.value}
                style={{ width: "100%", height: 200 }}
              />
            </FormGroup>

            <div className="nz-button-panel">
              <Button
                intent="primary"
                onClick={this.handleSave}
                loading={this.obs.saving}
              >
                Salvar
              </Button>
              <Button disabled={this.obs.saving} onClick={this.handleCancel}>
                Cancelar
              </Button>
            </div>
          </MDBCol>
        </MDBRow>
      </div>
    );
  }
}

export default NotaVarFcpForm;
